import React, { FC } from 'react';
import { StatusBadge, StatusBadgeType } from '../../UI';
import { ClassificationOption, SlideRowDisplayLevel } from '../../../interfaces';
import {
  newSlideColor,
  newSlideBackground,
  newVersionColor,
  newVersionBackground,
  duplicateSlideColor,
  duplicateSlideBackground,
} from '../../../themes';

export const SLIDE_ROW_LEVEL_COLOR: Record<SlideRowDisplayLevel, string> = {
  [SlideRowDisplayLevel.New]: newSlideColor,
  [SlideRowDisplayLevel.Similar]: newVersionColor,
  [SlideRowDisplayLevel.Duplicate]: duplicateSlideColor,
};

export const SLIDE_ROW_LEVEL_BACKGROUND: Record<SlideRowDisplayLevel, string> = {
  [SlideRowDisplayLevel.New]: newSlideBackground,
  [SlideRowDisplayLevel.Similar]: newVersionBackground,
  [SlideRowDisplayLevel.Duplicate]: duplicateSlideBackground,
};

export const STATUS_TO_CLASSIFICATION: Record<SlideRowDisplayLevel, ClassificationOption> = {
  [SlideRowDisplayLevel.New]: ClassificationOption.NewSlide,
  [SlideRowDisplayLevel.Similar]: ClassificationOption.VersionUpdate,
  [SlideRowDisplayLevel.Duplicate]: ClassificationOption.Duplicate,
};

export const CLASSIFICATION_TO_STATUS: Record<ClassificationOption, SlideRowDisplayLevel> = {
  [ClassificationOption.VersionUpdate]: SlideRowDisplayLevel.Similar,
  [ClassificationOption.NewSlide]: SlideRowDisplayLevel.New,
  [ClassificationOption.Duplicate]: SlideRowDisplayLevel.Duplicate,
};

const LEVEL_TO_BADGE_TYPE: Record<SlideRowDisplayLevel, StatusBadgeType> = {
  [SlideRowDisplayLevel.New]: 'new',
  [SlideRowDisplayLevel.Similar]: 'newVersion',
  [SlideRowDisplayLevel.Duplicate]: 'duplicate',
};

export const StyledStatusBadge: FC<{ $level: SlideRowDisplayLevel }> = ({ $level }) => (
  <StatusBadge $type={LEVEL_TO_BADGE_TYPE[$level]} />
);
